var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/use-ember-data-rfc-395-imports

export let APPROVAL_STATUS = /*#__PURE__*/function (APPROVAL_STATUS) {
  APPROVAL_STATUS["PENDING"] = "PENDING";
  APPROVAL_STATUS["APPROVED"] = "APPROVED";
  APPROVAL_STATUS["DISAPPROVED"] = "DISAPPROVED";
  return APPROVAL_STATUS;
}({});
let ChannelObject = (_dec = attr('string'), _dec2 = attr('number'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('json-or-value'), _dec6 = attr('number'), _dec7 = attr('number'), _dec8 = attr('string'), _dec9 = attr('json-or-value'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('date'), _dec13 = attr('date'), _dec14 = attr('date'), _dec15 = belongsTo('channels/channel'), _dec16 = belongsTo('channels/object-map'), _dec17 = computed('approvalStatus'), _dec18 = computed('approvalStatus'), _dec19 = computed('approvalStatus'), _class = class ChannelObject extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "merchantId", _descriptor, this);
    _initializerDefineProperty(this, "channelId", _descriptor2, this);
    _initializerDefineProperty(this, "externalObjectId", _descriptor3, this);
    _initializerDefineProperty(this, "objectType", _descriptor4, this);
    _initializerDefineProperty(this, "objectData", _descriptor5, this);
    _initializerDefineProperty(this, "objectDeleted", _descriptor6, this);
    _initializerDefineProperty(this, "objectDisabled", _descriptor7, this);
    _initializerDefineProperty(this, "approvalStatus", _descriptor8, this);
    _initializerDefineProperty(this, "metaData", _descriptor9, this);
    _initializerDefineProperty(this, "version", _descriptor10, this);
    _initializerDefineProperty(this, "revision", _descriptor11, this);
    _initializerDefineProperty(this, "createdAt", _descriptor12, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor13, this);
    _initializerDefineProperty(this, "deletedAt", _descriptor14, this);
    _initializerDefineProperty(this, "channel", _descriptor15, this);
    _initializerDefineProperty(this, "objectMap", _descriptor16, this);
  }
  get isApproved() {
    return this.approvalStatus === APPROVAL_STATUS.APPROVED;
  }
  get isPending() {
    return this.approvalStatus === APPROVAL_STATUS.PENDING;
  }
  get isDisapproved() {
    return this.approvalStatus === APPROVAL_STATUS.DISAPPROVED;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "channelId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "externalObjectId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "objectType", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "objectData", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "objectDeleted", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "objectDisabled", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "approvalStatus", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "metaData", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "version", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "revision", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "deletedAt", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "channel", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "objectMap", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isApproved", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isApproved"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPending", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "isPending"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisapproved", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "isDisapproved"), _class.prototype), _class);
export { ChannelObject as default };